import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const noop = () => {};
@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: CheckboxComponent, multi: true }
    ],
    standalone: false
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
    @Input() label: string;
    @Input() disabled: boolean;

    @ViewChild('checkbox', { static: true }) checkbox;

    private innerChecked: boolean;

    public checked: boolean;

    private onTouchedCallback: (_: any) => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    constructor() {}

    ngOnInit() {}

    writeValue(val: any): void {
        if (val !== this.innerChecked) {
            this.innerChecked = val;
            this.checked = val;
        }
    }
    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
    setDisabledState?(isDisabled: boolean): void {}

    get value(): any {
        return this.innerChecked;
    }

    // set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.innerChecked) {
            this.innerChecked = v;
            this.onChangeCallback(v);
        }
    }

    onClick() {
        this.setState();
    }

    private setState() {
        this.checked = !this.innerChecked;
        this.value = this.checked;
    }
}
